import { Text } from "@ui-kitten/components";
import React from "react";
import { View } from "react-native";
import { heroGradient } from "../helpers";

interface Props {
  kicker?: string;
  heading: string;
  subheading?: string;
  primaryColor: string;
}

// Landing hero (prototype's fgm-hero-v2): rounded card, tenant-color
// gradient with a faint diagonal stripe overlay, gold kicker, white
// heading and copy. Raw div for the CSS gradient — this screen set is
// web-only.
const HeroBannerV3 = ({ kicker, heading, subheading, primaryColor }: Props) => (
  <View className="pt-6 pb-6">
    <div
      data-testid="v3-hero-banner"
      style={{
        borderRadius: 18,
        padding: "22px 24px",
        minHeight: 176,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflow: "hidden",
        backgroundImage: heroGradient(primaryColor),
        backgroundColor: primaryColor,
      }}
    >
      {kicker ? (
        <Text
          category="c1"
          style={{
            color: "#f2cf9e",
            fontWeight: "600",
            letterSpacing: 1.5,
            textTransform: "uppercase",
          }}
        >
          {kicker}
        </Text>
      ) : null}
      <Text
        style={{
          color: "#ffffff",
          fontSize: 32,
          lineHeight: 37,
          fontWeight: "500",
          letterSpacing: -0.5,
          maxWidth: 340,
          marginTop: 12,
          marginBottom: 8,
        }}
      >
        {heading}
      </Text>
      {subheading ? (
        <Text
          style={{
            color: "rgba(255,255,255,0.88)",
            fontSize: 16,
            lineHeight: 23,
            maxWidth: 320,
          }}
        >
          {subheading}
        </Text>
      ) : null}
    </div>
  </View>
);

export default HeroBannerV3;
